"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pond = void 0;
const Storage_1 = require("./Storage");
const typeName = 'Pond';
class Pond extends Storage_1.Storage {
    constructor(ob) {
        var _a, _b, _c;
        super({ ...ob, type: (_a = ob.type) !== null && _a !== void 0 ? _a : typeName });
        this.floorSize = (_b = ob.floorSize) !== null && _b !== void 0 ? _b : null;
        this.topArea = (_c = ob.topArea) !== null && _c !== void 0 ? _c : null;
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            // name: { type: 'String', editable: true, label: 'Name', name: 'name', description: 'Name of pond' },
            purpose: { type: 'String', editable: true, label: 'Purpose', name: 'purpose', description: 'Used for' },
            diameter: {
                type: 'Number',
                required: false,
                editable: true,
                label: 'Diameter',
                hidden: true,
                name: 'diameter',
                description: 'Diameter of pond - metre.cm',
            }, // this attribute does not exist on a pond
            depth: { type: 'Number', required: true, editable: true, label: 'Depth', name: 'depth', description: 'Depth of pond in m.cm' },
            // floorSize: { type: 'Number', required: true, editable: true, label: 'Floor Size', name: 'floorSize', description: 'Area of the floor of the pond in m2' },
            // topArea: { type: 'Number', required: true, editable: true, label: 'Top Area', name: 'topArea', description: 'Area of the top of the pond in m2' },
            surfaceWidth: { type: 'Number', required: true, editable: true, label: 'Surface Width', name: 'Surface Width', description: 'Surface Width in m' },
            bottomWidth: { type: 'Number', required: true, editable: true, label: 'Bottom Width', name: 'Bottom Width', description: 'Bottom Width in m' },
            surfaceLength: { type: 'Number', required: true, editable: true, label: 'Surface Length', name: 'Surface Length', description: 'Surface Length in m' },
            bottomLength: { type: 'Number', required: true, editable: true, label: 'Bottom Length', name: 'Bottom Length', description: 'Bottom Length in m' },
            constructionMaterial: {
                type: 'String',
                editable: true,
                label: 'Construction material',
                name: 'constructionMaterial',
                description: 'Material dam is contructed from if artifical',
            },
            comments: { type: 'String', editable: true, label: 'Comments', name: 'comments', description: 'Free text for info ' },
        };
    }
}
exports.Pond = Pond;
